import React from "react";
import AdminResizableSplit from "./AdminResizableSplit";

/**
 * Filter rail + main workspace (used on most admin desk pages).
 */
export default function AdminDesk({ sectionKey, sidebarLabel, sidebar, children }) {
  return (
    <div className="am-desk-wrap">
      <AdminResizableSplit
        storageKey={`bb-admin-desk-rail:${sectionKey}`}
        defaultSize={236}
        minSize={168}
        maxSize={400}
        className="am-desk"
        leadClassName="am-desk-sidebar"
        leadAriaLabel={sidebarLabel}
        trailClassName="am-desk-main"
        lead={sidebar}
        trail={children}
      />
    </div>
  );
}
